'use client'

import React from 'react'
import { Heading } from '@/components/ui/heading'
import { CMSLink } from '@/components/Link'
import RichText from '@/components/RichText'
import { CalloutStripBlock } from '@/payload-types'
import { cn } from '@/utilities/ui'

export function CalloutStripClient({ heading, message, links }: CalloutStripBlock) {
  return (
    <div className="text-dark bg-powder py-[30px]">
      <div className="container mx-auto px-4 flex flex-col gap-y-[20px] lg:gap-x-[20px] lg:flex-row lg:items-center lg:justify-between">
        {heading && (
          <Heading size="h4" className="text-balance lg:min-w-[300px]">
            {heading}
          </Heading>
        )}
        {message && <RichText data={message} className="text-balance" />}
        <div
          className={cn(
            'flex',
            'flex-col gap-y-[10px]',
            'md:flex-row md:gap-x-[10px]',
            'lg:flex-col lg:gap-y-[10px]',
            'xl:flex-row xl:gap-x-[10px]',
          )}
        >
          {links?.map((link) => <CMSLink key={link.id} {...link.link} />)}
        </div>
      </div>
    </div>
  )
}
